import styles from './header.module.scss'
import Button from './Button';
import { useEffect, useState } from 'react';

interface HeaderProps {
    workRef: React.RefObject<HTMLDivElement>;
    contactRef: React.RefObject<HTMLDivElement>;
}

const Header: React.FC<HeaderProps> = ({ workRef, contactRef }) => {
    const [active, setActive] = useState<string>('Work');

    const scrollTo = (ref: React.RefObject<HTMLDivElement>, section: string) => {
        setActive(section);
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        const workEl = workRef.current;
        const contactEl = contactRef.current;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        if (entry.target === workEl) setActive('Work');
                        else if (entry.target === contactEl) setActive('Contact');
                    }, 300);
                });
            },
            { threshold: 0.7 }
        );

        if (workEl) observer.observe(workEl);
        if (contactEl) observer.observe(contactEl);

        return () => {
            clearTimeout(timeout);
            if (workEl) observer.unobserve(workEl);
            if (contactEl) observer.unobserve(contactEl);
        };
    }, []);

    return (
        <div className={styles.header}>
            <img src="images/logo.svg" className={styles.logo} alt="Ulmsoft logo" />
            <div className={styles.buttons}>
                <Button title='Work' active={active === 'Work'} onClick={() => scrollTo(workRef, 'Work')} />
                <Button title='Contact' active={active === 'Contact'} onClick={() => scrollTo(contactRef, 'Contact')} />
            </div>
        </div>
    );
};

export default Header;
